import { prefix } from "./constants.js";
import { createAction } from "typesafe-actions";
const replaceIsolationGroup = createAction(`${prefix}/MERGE`, (action) => (result) => action(result));
const appendIsolationGroup = createAction(`${prefix}/APPEND`, (action) => (result) => action(result));
export {
  appendIsolationGroup,
  replaceIsolationGroup
};
//# sourceMappingURL=actions.js.map
